import { useContext, useEffect } from 'react';
import UserProgressContext from '../../userProgressContext';
import SoundManager from '../../services/SoundManager';

/**
 * AudioController — bridges UserProgressContext audio state to SoundManager.
 * Renders nothing. Mount once in RootLayout.
 */
const AudioController = () => {
  const { audioSrc, audioMuted } = useContext(UserProgressContext);

  useEffect(() => {
    SoundManager.setMuted(audioMuted);
  }, [audioMuted]);

  useEffect(() => {
    SoundManager.playTrack(audioSrc);
  }, [audioSrc]);

  return null;
};

export default AudioController;
